import React from 'react';
import _ from 'lodash';

import { IRosterShift } from '../../types';
import OpenShiftCard from './OpenShiftCard';

interface OpenShiftsListProps {
  unassignedShifts: IRosterShift[][];
}

export const OpenShiftsList = ({ unassignedShifts }: OpenShiftsListProps) => {
  return (
    <>
      {unassignedShifts.map((shiftGroup, rowIdx) =>
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        shiftGroup.map((shift, shiftIdx) => <OpenShiftCard shift={shift} key={shiftIdx} rowIndex={rowIdx} />),
      )}
    </>
  );
};
